import { useEffect } from 'react';
import { useVideoStore } from './useVideoStore';

export function usePlayPauseOnIntersection(enabled: boolean) {
  const { root, setIsPlaying } = useVideoStore((state) => ({
    root: state.root,
    setIsPlaying: state.setIsPlaying,
  }));

  useEffect(() => {
    if (!enabled) return;

    function intersectionObserverCallback(
      entries: IntersectionObserverEntry[]
    ) {
      const [entry] = entries;
      setIsPlaying(entry.isIntersecting);
    }

    const observer = new IntersectionObserver(intersectionObserverCallback, {});
    if (root) {
      observer.observe(root);
    }

    return () => observer.disconnect();
  }, [enabled, root, setIsPlaying]);
}
